import { apiClient } from './client';

export interface ProfitAllocation {
  id: string;
  created_at: string;
  profit_entry_id: string;
  profit_entry_date: string;
  profit_entry_notes?: string;
  ownership_percent: number;
  gross_share_cents: number;
  company_cut_percent: number;
  company_cut_cents: number;
  net_share_cents: number;
}

export interface PaginationInfo {
  page: number;
  per_page: number;
  total_count: number;
  total_pages: number;
}

export interface AllocationListResponse {
  allocations: ProfitAllocation[];
  pagination: PaginationInfo;
  page_totals: {
    gross_share_cents: number;
    company_cut_cents: number;
    net_share_cents: number;
  };
}

export interface AllocationFilters {
  from?: string;
  to?: string;
  page?: number;
  per?: number;
}

export const allocationEndpoints = {
  // Get current user's allocations
  getMyAllocations: (filters?: AllocationFilters) => {
    const params = new URLSearchParams();
    if (filters?.from) params.append('from', filters.from);
    if (filters?.to) params.append('to', filters.to);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.per) params.append('per', filters.per.toString());
    
    const queryString = params.toString();
    return apiClient.get<AllocationListResponse>(
      `/api/profit_allocations${queryString ? `?${queryString}` : ''}`
    );
  },
};

export default allocationEndpoints;
